// extracted by mini-css-extract-plugin
module.exports = {"notification-category":"notification-category__3BYAw","red":"red__1ZQX9","gray":"gray__1Tjlv"};